import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle-check",
  "use": "icon-circle-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-circle-check\"><path d=\"M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.75-7.33l6.293-6.294a1 1 0 011.414 1.414l-7 7a1 1 0 01-1.414 0l-3.417-3.416A1 1 0 017.54 11.96l2.71 2.71z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol